import { useSelector } from 'react-redux';
import { FormTitle, LabeledTextField, ScrollContainer } from "./components";
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Spinner from '../spinner/Spinner';
import GridSpacer from './components/gridSpacer';
import { useTechAssistCallsForDealer } from '../../fetch/fetchTechAssist';
import { logFeatureUsage } from '../../fetch/insightsHelper';

export default function TechnicalAssistanceListPage() {
    const navigate = useNavigate();
    const isPermissionsLoaded = useSelector((state) => state.permissions.isLoaded);
    const hasTechAssist = useSelector((state) => state.permissions.hasTechAssist);

    useEffect(() => {
        if (isPermissionsLoaded && !hasTechAssist) {
            navigate('/');
        }
    }, [isPermissionsLoaded, hasTechAssist]);

    const [serialNumber, setSerialNumber] = useState('');

    useEffect(() => {
        document.title = 'Mercury Literature - Tech Assistance Request';
        logFeatureUsage("TechAssistList");
    }, []);

    const { data: callsForDealer, isLoading } = useTechAssistCallsForDealer(serialNumber);

    return (
        <ScrollContainer>
            <Grid container spacing={2}>
                <FormTitle title="Tech Assistance Request Form" />
                <LabeledTextField
                    label="Serial Number"
                    value={serialNumber || ''}
                    onChange={(e) => setSerialNumber(e.target.value)}
                    size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}
                />
                <GridSpacer size={{ xs: 0, sm: 6, md: 8, lg: 9, xl: 10 }} />
                <Grid size={12}>
                    <Button
                        onClick={() => navigate(`/literature/techAssist/${serialNumber}`)}
                        disabled={!serialNumber}
                    >
                        Next
                    </Button>
                </Grid>
                <Grid size={12}>
                    <Typography variant="h6" gutterBottom style={{ fontSize: '1.5rem', padding: '0.5rem' }}>
                        Open Tech Assist Requests
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Reference Number</TableCell>
                                    <TableCell>Serial Number</TableCell>
                                    <TableCell>Call Date</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Activity Date</TableCell>
                                </TableRow>
                            </TableHead>

                            {callsForDealer && callsForDealer.length > 0 ? (
                                <TableBody>
                                    {callsForDealer.map((call) => (
                                        <TableRow key={call.referenceNumber}>
                                            <TableCell>{call.consumerFirstName} {call.consumerLastName}</TableCell>
                                            <TableCell>{call.referenceNumber}</TableCell>
                                            <TableCell>{call.serialNumber}</TableCell>
                                            <TableCell>{call.callDate}</TableCell>
                                            <TableCell>{call.callStatusDescription}</TableCell>
                                            <TableCell>{call.activityDate}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6} sx={{ textAlign: 'center' }}>{!isLoading ? "No Results" : <Spinner width={20} />}</TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </ScrollContainer>
    );
}